module.exports = __webpack_public_path__ + "static/media/clock.87b9d23d.svg";